// axios
import axios from "axios";

var baseURL = '';
if(process.env.NODE_ENV != 'production'){
  baseURL = "/api/";
}else{
  baseURL = "/api/";
}

export default axios.create({
  baseURL
  // You can add your headers here
});
